import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  saveWithRateShopper: {
    defaultMessage: '<s>Save</s> <savings></savings> by using Rate Shopper for this shipment',
    description: 'Banner text encouraging the merchant to save money by using Rate Shopper',
    id: 'yR+u2V',
  },
  recommendationApplyButton: {
    description: 'Prompt for merchant to apply a rate recommendation to the shipment',
    defaultMessage: 'Apply & Save',
    id: '/q4kE3',
  },
});
